<template>
    <sections>
        <section-text
            color="bg-zinc-50"
            heading="Dance Shoes"
            content="<p>By far the question Lauren gets asked most - what are those shoes?!<br />Read on to find out!</p>"
        ></section-text>
        <section-image
            :image="hero.image"
            :imageSet="hero.imageSet"
            :imageSizes="hero.imageSizes"
            imageLoading="eager"
            imagePriority="high"
            heading="SwayD Alex"
            content="<article-shoes-alex />"
            :flip="true"
        ></section-image>
        <section-text color="bg-zinc-50" heading="More Options" content="<article-shoes-swayd />"></section-text>
    </sections>
</template>

<script setup>
const $config = useRuntimeConfig();

// https://www.responsivebreakpoints.com/
// https://cloudinary.com/tools/jpg-to-webp
const hero = {
    imageSizes: '(max-width: 1200px) 100vw, 1200px',
    imageSet: `
        ${$config.public.images}dance-shoes-512.webp 512w,
        ${$config.public.images}dance-shoes-1200.webp 1200w
    `,
    image: `${$config.public.images}dance-shoes.jpg`,
};

useSeo().buildHead({
    image: $config.public.images + 'dance-shoes.jpg',
    title: 'Dance Shoes | Lauren Jones',
    description: "Lauren's recommended dance shoes.",
    index: true,
});
</script>
